import React from "react";

const About = () => {
  return (
    <>
          <div id="about" class="row my-auto">
            <div class="col-12 col-md-6 offset-md-3 mt-3">
                  <h1 class="text-center">About Dealer's Choice</h1>
                  <p>Dealer's Choice allows you to play any game you like with any rules or variations you want.</p>
                  <p>We've been playing together since high school and have developed many variations that other online poker sites don't allow.</p>
                  <p>We wanted to play our way, so we built a game that allows us to.</p>
                  <p>We hope you enjoy it as much as we do!</p>
            </div>
          </div>
    </>
  );
};

export default About;
